/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Compare_Row_Price_AcInputs */

const en_cad_compare_row_price_ac = /** @type {(inputs: Cad_Compare_Row_Price_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid subscription (about $2,000/year list price)`)
};

/**
* | output |
* | --- |
* | "Paid subscription (about $2,000/year list price)" |
*
* @param {Cad_Compare_Row_Price_AcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_compare_row_price_ac = /** @type {((inputs?: Cad_Compare_Row_Price_AcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Compare_Row_Price_AcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_compare_row_price_ac(inputs)
});
export { cad_compare_row_price_ac as "cad.compare.row_price_ac" }